export default "__VITE_ASSET__DruoO$OE__"